import React from 'react';
import { Modal } from 'react-bootstrap';
import './Onboarding.css';

interface CompletionModalProps {
    show: boolean;
    onClose: () => void;
}

const CompletionModal: React.FC<CompletionModalProps> = ({ show, onClose }) => {
    return (
        <Modal
            show={show}
            centered
            size="sm"
            backdrop="static"
            keyboard={false}
            dialogClassName="onb-welcome-modal"
            backdropClassName="onb-welcome-backdrop"
            onHide={onClose}
        >
            <Modal.Body>
                {/* Decorative sparkles */}
                <div className="onb-sparkle-container">
                    <span className="onb-sparkle" />
                    <span className="onb-sparkle" />
                    <span className="onb-sparkle" />
                    <span className="onb-sparkle" />
                    <span className="onb-sparkle" />
                    <span className="onb-sparkle" />
                </div>

                <div className="onb-completion-icon">🎉</div>

                <h2 className="onb-welcome-heading">You're All Set!</h2>

                <p className="onb-welcome-subtext">
                    You've completed the tour. You now know the key areas of Falchion Xenia.
                    Dive in and start managing your restaurant like a pro!
                </p>

                <div className="onb-completion-tips">
                    <div className="onb-completion-tip">
                        <span className="onb-completion-tip-icon">💡</span>
                        <span>You can replay this tour anytime from your <strong>Profile Menu</strong></span>
                    </div>
                    <div className="onb-completion-tip">
                        <span className="onb-completion-tip-icon">✨</span>
                        <span>Use the <strong>AI Assistant</strong> for instant help and insights</span>
                    </div>
                </div>

                <button className="onb-start-btn" onClick={onClose}>
                    🚀 Let's Go!
                </button>
            </Modal.Body>
        </Modal>
    );
};

export default CompletionModal;
